module.exports = __webpack_public_path__ + "img/03.277d5237.png";